<template>
  <div
    class="invisible-area"
    :style="styleObject"
    v-on="inputListeners"
  >
    <div
      v-show="alwaysVisible || visible"
      ref="dropdownList"
      :class="['dropdown-list', extraRound ? 'extra-round' : '']"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
    >
      <v-list
        :class="[
          'list-component',
          'pa-0',
          extraRound ? 'extra-round' : '',
          scrollable ? 'scrollable' : '',
        ]"
        :style="{ width: dropdownData.listWidth }"
        @mouseenter="mouseenter"
        @mouseleave="mouseleave"
      >
        <slot />
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubmenuDropdownList',
  inject: {
    dropdownData: {
      default: () => ({
        outsideRoot: () => {},
        handleActiveElementChange: () => {},
      }),
    },
  },
  props: {
    alwaysVisible: { type: Boolean, default: false },
    depth: { type: Number, default: 0 },
    invisibleArea: { type: Number, default: 0 },
    extraRound: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    top: { type: Number, default: null },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    styleObject() {
      const fieldName = this.dropdownData.right && this.depth === 0 ? 'right' : 'left';
      return {
        [fieldName]: this.depth === 0 ? '-1px' : '100%',
        top: this.depth === 0 ? `${this.dropdownData.dropdownOffsetHeight}px` : '-1px',
        paddingTop: this.depth === 0 ? `${this.invisibleArea}px` : '0px',
        position: 'absolute',
        minWidth: this.dropdownData.minWidth,
      };
    },
    activeElement() {
      return this.dropdownData.activeElement;
    },
    inputListeners() {
      const vm = this;
      // `Object.assign` merges objects together to form a new object
      return {
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        // This ensures that the component works with v-model
        'update:modelValue': function (event) {
          vm.$emit('update:modelValue', event.target.value);
        },
      };
    },
  },
  watch: {
    activeElement() {
      if (this.checkIfElementIsActive()) {
        this.visible = true;
      } else {
        // add a small timeout for a case when mouse moves from the activator to the menu content
        setTimeout(() => {
          if (!this.checkIfElementIsActive()) {
            this.visible = false;
          }
        }, 200);
      }
    },
  },
  methods: {
    mouseenter(e) {
      this.dropdownData.handleActiveElementChange(e.target);
    },
    mouseleave(e) {
      if (this.dropdownData.outsideRoot(e.relatedTarget)) {
        this.dropdownData.handleActiveElementChange(null);
      }
    },
    checkIfElementIsActive() {
      const { activeElement } = this.dropdownData;
      const { parentElement } = this.$refs.dropdownList?.parentElement || [];
      return activeElement
        && (activeElement === parentElement || parentElement.contains(activeElement));
    },
  },
};
</script>

<style lang="less" scoped>
.invisible-area {
  position: absolute;
  z-index: 10;
}
.dropdown-list {
  border: 0;
  box-shadow: 0 10px 50px 0 fade(@grey-900, 10%);
  border-radius: 8px;
}

.v-list {
  border-radius: 8px!important;
}
.list-component {
    border-radius: 8px;
}
.v-list :deep(*:first-child .v-list-item),
.v-list :deep(*:first-child .v-list-item::before),
.v-list :deep(*:first-child .v-list-item-container)
 {
  border-radius: 8px 8px 0 0!important;
}
.v-list :deep(*:last-child .v-list-item),
.v-list :deep(*:last-child .v-list-item::before),
.v-list :deep(*:last-child .v-list-item-container) {
  border-radius: 0 0 8px 8px!important;
}
.dropdown-list.extra-round {
  border-radius: 10px;
}
.v-list.extra-round {
  border-radius: 10px!important;
}
.list-component.extra-round {
  border-radius: 10px;
}
.v-list.extra-round :deep(*:first-child .v-list-item),
.v-list.extra-round :deep(*:first-child .v-list-item::before),
.v-list.extra-round :deep(*:first-child .v-list-item-container)
 {
  border-radius: 10px 10px 0 0!important;
}
.v-list.extra-round :deep(*:last-child .v-list-item),
.v-list.extra-round :deep(*:last-child .v-list-item::before),
.v-list.extra-round :deep(*:last-child .v-list-item-container) {
  border-radius: 0 0 10px 10px!important;
}
.scrollable.v-list {
  position: relative;
  max-height: 388px;
  overflow-y: scroll;
}
</style>
